/**
 * Outcome of ONE run of the provision simulation (`POST /mvsa/cp/provisionTypes/{id}/simulate`).
 *
 * ── ALL FIVE CONSTANTS ARE ANSWERS, NOT FAILURES
 *
 * The endpoint replies with HTTP 200 for every one of them — measured on 2026-09-02 against
 * clone/rathje. `NOT_ELIGIBLE`, `NO_EVENT` and `CONFIGURATION_ERROR` are what the configuration
 * SAYS about the entered contract, and each arrives together with the protocol step that produced
 * it. A surface that renders them as an error swallows the very answer the user asked for; a
 * surface that renders them as an empty page is worse still. HTTP 400 is reserved for a request
 * that is not a question at all.
 *
 * Position-based mirror of the backend enum {@code com.mvs.backend.cp.enums.ProvisionSimulationState}.
 * The wire form is the ORDINAL (measured: `"state": 0` beside `"stateInfo": {…}`), so the
 * declaration order below MUST match the backend exactly and new constants MUST only be appended
 * at the end — never inserted between existing ones (02-datenmodell.md §0.5/§2).
 *
 * The German label comes from the accompanying `stateInfo` block. There is deliberately no label
 * map for this enum on the frontend side: `stateInfo` has been delivered from the first version of
 * the endpoint, so a second source of wording would only ever be a way to disagree with it.
 */
export enum ProvisionSimulationState {

    /** Ordinal 0 — the chain ran through and produced entitlements. */
    COMPLETED,

    /** Ordinal 1 — the eligibility rules (K-05) deny this contract. */
    NOT_ELIGIBLE,

    /** Ordinal 2 — the configuration produces no commission event for this contract. */
    NO_EVENT,

    /** Ordinal 3 — the calculation chain reported an error and froze the event. */
    ERROR,

    /** Ordinal 4 — the provision type is incompletely configured and can book nothing. */
    CONFIGURATION_ERROR
}
